import * as React from "react";

export const AsyncFallbackWrapper: React.FunctionComponent = ({ children }) => (
  <div className="async-wrapper">{children}</div>
);
